import Form from "./components/Form";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route} from 'react-router-dom'


function App() {
 

  return ( 
 
  <BrowserRouter>
  <Routes>
      <Route path="/" element={<Form/>}></Route> 
      <Route path="*" element={<Form/>}></Route> 
  </Routes>
  </BrowserRouter>
  )
  
  
}

export default App;